export const Badge = {
  baseStyle: {
    color: 'white',
    textTransform: 'none',
    borderRadius: 'sm',
  },
  variants: {
    error: {
      backgroundColor: 'brand.red',
    },
    warning: {
      backgroundColor: 'orange.300',
    },
    success: {
      backgroundColor: 'brand.green',
    },
    active: {
      backgroundColor: '#41B305',
    },
    inactive: {
      backgroundColor: '#D80808',
    },
    pending: {
      backgroundColor: '#F8BC4C',
    },
    tag: {
      backgroundColor: 'brand.primary',
      borderRadius: '4px',
      fontSize: '10px',
      fontWeight: 500,
    },
    neutral: {
      backgroundColor: 'neutral.0',
      border: '1px solid',
      borderColor: 'neutral.100',
      borderRadius: '6px',
      paddingX: 2,
      paddingY: 1,
      fontSize: '10px',
      fontWeight: 700,
      color: 'baseBlack',
    },
    warmNeutral: {
      backgroundColor: 'warmNeutral.100',
      border: '1px solid',
      borderColor: 'warmNeutral.300',
      borderRadius: '6px',
      paddingX: 2,
      paddingY: 1,
      fontSize: '10px',
      fontWeight: 700,
      color: 'baseBlack',
    },
  },
};
